import * as React from 'react';
import { MemoryRouter } from 'react-router-dom';
import { PlanListLayout } from './';

/**
 * Renders the plans admin panel page.
 */
const AdminPlansScene: React.SFC = () => (
    <MemoryRouter>
        <PlanListLayout />
    </MemoryRouter>
);

export default AdminPlansScene;

